
import { useState } from "react";
import { useGetSecMagasinsQuery } from "../../../redux/features/cache";
import { SecMagasin } from "../../../models/SecMagasin";
import FormMagasin from "./Forms/FormMagasin";
import { Box, Button, Typography } from "@mui/material";
import GenericModal from "../modals/GenericModal";
import { getModalStyle } from "../../modalStyle";
import MagasinForm from "../../section2/component/MagasinForm";
import { useAppSelector } from "../../../redux/store";

interface IWrapperMagasin {
    sec: number
    mag: string
    plans_nom: string
}

export default function WrapperMagasin({ sec, mag, plans_nom }: IWrapperMagasin) {
    const { data: secMagasins = [] as SecMagasin[] } = useGetSecMagasinsQuery({ sec, mag });
    const [open, setOpen] = useState<boolean>(false);
    const d_inv01rp = useAppSelector(state => state.appState.d_inv01rp);

    return (
        <>
            <GenericModal
                open={open}
                handleClose={() => setOpen(false)}
                style={getModalStyle}
                title="Ajouter un nouveau magasin">
                    <MagasinForm plans_seq={sec} setOpen={setOpen} canDelete={d_inv01rp.canDelete}/>
            </GenericModal>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, minWidth: '35vw' }}>
                <Typography variant="h5" sx={{ color: '#007bff' }} >{plans_nom}</Typography>

                <Button variant='contained' onClick={()=> setOpen(true)} sx={{ width: '300px', borderRadius: '30px', backgroundColor: '#007bff', color: 'white' }} disabled={!d_inv01rp.canAdd}>Ajouter un magasin</Button>
            </Box>
            {secMagasins &&
                secMagasins.map((e, i) => (
                    <FormMagasin data={e} key={e.mag_num} />
                ))}

        </>
    );
}


